<template>
  <div class="login primary-bg">
    <form
      action="https://idp.ewage.co.uk/oauth2/authorize"
      method="POST"
      ref="hiddenForm"
      style="display: none;"
    >
      <input
        type="hidden"
        name="client_id"
        :value="$store.getters.faApplicationId"
      />
      <input type="hidden" name="grant_type" value="password" />
      <input type="hidden" name="loginId" v-model="username" />
      <input
        type="hidden"
        name="password"
        v-model="newPassword ? newPassword : password"
      />
      <input type="hidden" name="scopes" value="offline_access" />
      <input type="hidden" name="tenantId" :value="$store.getters.faTenantId" />
      <input type="hidden" name="redirect_uri" :value="redirectURI" />
      <input type="hidden" name="response_type" value="token" />
    </form>
    <div v-if="!sso">
      <div
        :style="
          `background-image: url(${require('../../assets/watermark-logo.png')})`
        "
        class="login__container"
      >
        <div class="mdl-grid">
          <div class="mdl-cell mdl-cell--6-col mdl-cell--0-col-tablet"></div>
          <div class="mdl-cell mdl-cell--6-col mdl-cell--12-col-tablet">
            <div class="login__container__body">
              <img
                class="login__logo"
                v-if="clientLogo"
                :src="clientLogo"
                alt="Logo"
              />
              <h4
                class="mb--0"
                v-if="
                  $store.getters.clientId ===
                    '67c98dbe-5e9b-41a8-a35c-2e3b56e78c37'
                "
                v-text="isLogin ? 'Staff Login' : 'Staff Registration'"
              ></h4>
              <h4
                v-else
                class="mb--0"
                v-text="isLogin ? `${$store.getters.clientId === 'c07caf9b-cedd-405c-83d5-6dd911b5c1c1' ? `Worker Login` : `Employee Login`}` : `${$store.getters.clientId === 'c07caf9b-cedd-405c-83d5-6dd911b5c1c1' ? `Worker Registration` : `Employee Registration`}`"
              ></h4>
              <div class="mdl-card__supporting-text pt--0 pb--0">
                <p id="login-message" class="mb--0 mt--2"></p>
              </div>
              <div v-if="changePasswordId">
                <form @submit.prevent="changePassword">
                  <div class="mdl-card__supporting-text">
                    <p class="text--left">
                      Please enter a new password below to access your account.
                    </p>
                    <div class="login__field">
                      <input
                        class="login__field__input"
                        :class="{ active: newPassword && newPassword.length }"
                        type="password"
                        id="newPassword"
                        v-model="newPassword"
                      />
                      <label
                        class="login__field__label"
                        for="newPassword"
                        v-text="'New password'"
                      >
                      </label>
                    </div>
                    <div class="login__field">
                      <input
                        class="login__field__input"
                        :class="{
                          active:
                            newPasswordConfirm && newPasswordConfirm.length,
                        }"
                        type="password"
                        id="newPasswordConfirm"
                        v-model="newPasswordConfirm"
                      />
                      <label
                        class="login__field__label"
                        for="newPasswordConfirm"
                        v-text="'Confirm new password'"
                      >
                      </label>
                    </div>
                    <div class="login__errors" v-if="passwordMatchError">
                      <p v-text="'Passwords do not match'"></p>
                    </div>
                  </div>
                  <div class="mdl-card__actions">
                    <button
                      v-show="!busy"
                      type="submit"
                      class="mdl-button mdl-js-button mdl-button--raised login__btn secondary-bg"
                      v-text="'Change password'"
                    ></button>
                    <div
                      v-show="busy"
                      class="mdl-spinner mdl-js-spinner is-active"
                    ></div>
                  </div>
                </form>
              </div>
              <div v-else>
                <form @submit.prevent="login">
                  <div class="mdl-card__supporting-text">
                    <div class="login__field">
                      <input
                        class="login__field__input"
                        :class="{ active: username && username.length }"
                        type="text"
                        id="username"
                        v-model="username"
                        required
                      />
                      <label
                        class="login__field__label"
                        for="username"
                        v-text="loginLabel"
                      >
                      </label>
                    </div>
                    <div class="login__field">
                      <i v-if="password.length" class="material-icons eye" v-text="showPassword ? 'visibility_off' : 'visibility'" @click="showPassword = !showPassword"></i>
                      <input
                        class="login__field__input"
                        :class="{ active: password && password.length }"
                        :type="showPassword ? 'text' : 'password'"
                        id="userpass"
                        v-model="password"
                        required
                      />
                      <label
                        class="login__field__label"
                        for="userpass"
                        v-text="isLogin ? 'Password' : 'Surname'"
                      >
                      </label>
                    </div>
                    <div class="login__field login__field__checkbox">
                      <input type="checkbox" id="remember" v-model="remember" />
                      <label class="login__field__label login__field__label__checkbox" for="remember" v-text="`Remember me`"></label>
                    </div>
                    <div class="login__errors" v-if="error">
                      <p v-text="errorMessage"></p>
                    </div>
                  </div>
                  <div class="mdl-card__actions">
                    <button
                      v-show="!busy"
                      type="submit"
                      class="mdl-button mdl-js-button mdl-button--raised login__btn secondary-bg"
                    >
                      <span v-text="isLogin ? 'Login' : 'Register'"></span>
                      <i class="material-icons">keyboard_arrow_right</i>
                    </button>
                    <div
                      v-show="busy"
                      class="mdl-spinner mdl-js-spinner is-active"
                    ></div>
                  </div>
                </form>
              </div>
              <div class="forgot-password m--2 text--center">
                <router-link v-if="isLogin" to="/forgot-password"
                  >Forgot Password</router-link
                >
              </div>
              <div
                class="contact-number mt--4"
                v-if="showSapphireContactNumber"
              >
                Contact us:
                <a href="tel:01416487991">0141 648 7991</a>
              </div>
              <div class="mt--4">
                <div class="mdl-card__title text--left ml--2">
                  <p
                    v-text="
                      isLogin
                        ? 'If you are logging in for the first time click below to register.'
                        : 'Already have an account?'
                    "
                    class="text-color--black m--0"
                  ></p>
                </div>
                <div class="mdl-card__supporting-text p--0 w--100">
                  <!-- App Register mockup - remove afterwards -->
                  <router-link
                    v-if="$store.getters.clientId === 'a1c87148-6227-4643-b979-3bd7a973852e'"
                    :to="isLogin ? '/appregister' : '/login'"
                    class="mdl-button mdl-js-button mdl-button--raised login__btn secondary-bg text-color--white w--100"
                    tag="button"
                  >
                    <span v-text="isLogin ? 'Register' : 'Login'"></span>
                    <i class="material-icons">keyboard_arrow_right</i>
                  </router-link>
                  <router-link
                    v-else
                    :to="isLogin ? '/register' : '/login'"
                    class="mdl-button mdl-js-button mdl-button--raised login__btn secondary-bg text-color--white w--100"
                    tag="button"
                  >
                    <span v-text="isLogin ? 'Register' : 'Login'"></span>
                    <i class="material-icons">keyboard_arrow_right</i>
                  </router-link>
                </div>
              </div>
              <img
                id="ewage-logo"
                :src="require('../../assets/ewage-logo.png')"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import jwtDecode from 'jwt-decode'

export default {
  data: () => ({
    username: '',
    password: '',
    showPassword: false,
    error: false,
    errorMessage: '',
    changePasswordId: '',
    newPassword: null,
    newPasswordConfirm: null,
    oneTimePassword: '',
    busy: false,
    sso: true,
    remember: false
  }),
  computed: {
    showSapphireContactNumber() {
      return (
        this.$store.getters.clientId === '4426d3c3-6465-498c-9470-454d4d73d019'
      )
    },
    isLogin() {
      return this.$route.path === '/login'
    },
    passwordMatchError() {
      return this.newPassword !== this.newPasswordConfirm
    },
    redirectURI() {
      return `https://${window.location.hostname}/oauth`
    },
    clientLogo() {
      return this.$store.getters.clientLogo
    },
    loginLabel() {
      // Hotelcare & Lakethorne
      if (['6c3180a1-22cd-48a7-9dc0-9f5559ff0bf9', 'a4eda68c-de89-4bb2-86ed-2f5f4dddff29'].includes(this.$store.getters.clientId)) {
        return 'Employee Number'
      }

      // Red rock
      if (['c07caf9b-cedd-405c-83d5-6dd911b5c1c1'].includes(this.$store.getters.clientId)) {
        return 'Portal Code'
      }

      // Glen group
      if (['6cad92fc-669b-4dd0-946d-bb3a1490156d'].includes(this.$store.getters.clientId)) {
        return 'Payroll Number'
      }

      return 'NI Number'
    }
  },
  methods: {
    login() {
      this.busy = true

      if (this.remember) {
				localStorage.ewageUsername = this.username
			} else {
        localStorage.removeItem('ewageUsername')
      }

      let payload = {
        tenantId: this.$store.getters.faTenantId,
        applicationId: this.$store.getters.faApplicationId,
      }

      if (this.oneTimePassword) {
        payload.oneTimePassword = this.oneTimePassword
      } else {
        payload.loginId = this.username.replace(/\s/g, '')
        payload.password = this.password
      }

      window.axios
        .post(this.$store.getters.expressApi + 'login', payload)
        .then((response) => {
          if (!response.data.user && !response.data.changePasswordId) {
            return this.$router.push('/login-failure')
          }

          if (response.data.changePasswordId) {
            this.changePasswordId = response.data.changePasswordId
            this.busy = false
            this.$nextTick(() => {
              document.getElementById('newPassword').focus()
            })
            return
          }

          if (response.data && response.data.user && response.data.user.locked === 1) {
            this.error = true
            this.errorMessage = 'Invalid credentials.'
            // this.errorMessage = 'Account has been deactivated.'
            this.busy = false
            return
          }

          this.$store.commit('setUser', response.data.user)
          this.$store.commit('faToken', response.data.token)

          let path = localStorage.getItem('path') || '/'

          if (
            this.$refs.hiddenForm &&
            process.env.VUE_APP_SUBMIT_HIDDEN_FORM === 'true'
          ) {
            this.$refs.hiddenForm.submit()
          }

          this.$router.push(path, () => {
            this.$root.finishLogin()
          })
        })
        .catch((error) => {
          this.error = true
          this.errorMessage = error.response.data.message
          this.busy = false
        })
    },
    changePassword() {
      if (this.passwordMatchError) {
        return
      }

      window.axios
        .post(this.$store.getters.expressApi + 'change-password', {
          changePasswordId: this.changePasswordId,
          newPassword: this.newPassword,
        })
        .then((response) => {
          this.oneTimePassword = response.data.oneTimePassword
          this.login()
        })
    },
  },
  mounted() {
    if (localStorage.ewageUsername) {
			this.username = localStorage.ewageUsername
			this.remember = true
		}

    if (!this.$route.query.token) {
      this.sso = false
    } else {
      let decoded = jwtDecode(this.$route.query.token)
      this.username = decoded.data.user.identifier
      this.password = decoded.data.user.surname
      this.login()
    }
  },
}
</script>
